/**
 * Total da grid de Custas (AW2-1108 Etapa 0) — replica `TabelaCustas.calculateTotalCustas`
 * real: soma `valor` de cada custa, arredondado a 2 casas. Computado no client a partir do
 * array já carregado, nunca de um campo separado do DTO.
 */
export function calcularTotalCustas(custas) {
  if (!custas || custas.length === 0) {
    return 0;
  }

  const total = custas.reduce((soma, custa) => soma + custa.valor, 0);
  return parseFloat(total.toFixed(2));
}

/**
 * `detalhesValorCausa` é produzido por um editor rich-text (WYSIWYG) na tela
 * real — pode conter HTML puro (mesmo achado já documentado para o corpo de
 * e-mail em `AbaEmail.jsx` e a observação do cliente em `clienteController.js`).
 * Exibido sempre como texto simples, nunca `dangerouslySetInnerHTML` (AW2-1108
 * Etapa 0).
 */
export function removerTagsHtml(html) {
  return (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
